
import { computed, defineComponent, reactive } from 'vue'

import TheInput from '@/common/components/UI/TheInput/index.vue'
import Modal from '@/common/components/UI/Modal/index.vue'

import useNotifications from '@/common/composable/useNotifications'

import tmsAPI from '@/new-services/tms.service'

const BID_ACCEPT_STATUS_ID = 63
const BID_DECLINE_STATUS_ID = 64

export default defineComponent({
    props: {
        bidId: {
            type: Number,
            required: true,
        },
        isAccept: {
            type: Boolean,
            default: false,
        },
        isDecline: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        TheInput,
        Modal,
    },
    emits: ['status-changed', 'cancel'],
    setup(props, { emit }) {
        const notifications = useNotifications()

        const state = reactive({
            is_loading: false,
            comment: null as string | null,
        })

        const onSubmit = async () => {
            if (state.is_loading) return

            try {
                state.is_loading = true

                let statusId = null

                if (props.isAccept) {
                    statusId = BID_ACCEPT_STATUS_ID
                }

                if (props.isDecline) {
                    statusId = BID_DECLINE_STATUS_ID
                }

                await tmsAPI.changeBidStatusFtl(props.bidId, {
                    statusId: statusId as number,
                    comment: state.comment,
                })

                notifications.notify({ type: 'success', title: 'Статус изменен' })
                emit('status-changed')
            } catch (error) {
                console.error(error)
                notifications.notifyError({ error, title: 'При смене статуса произошла ошибка' })
            } finally {
                state.is_loading = false
            }
        }

        const onCancel = () => {
            if (state.is_loading) return
            emit('cancel')
        }

        const modalTitle = computed(() => {
            if (props.isDecline) {
                return 'Отказ'
            }

            return 'Подтверждение'
        })

        const confirmButtonClass = computed(() => {
            if (props.isDecline) {
                return 'small red'
            }

            return 'small primary'
        })

        const confirmButtonText = computed(() => {
            if (props.isDecline) {
                return 'Отказать'
            }

            return 'Подтвердить'
        })

        return {
            state,
            onSubmit,
            onCancel,
            modalTitle,
            confirmButtonClass,
            confirmButtonText,
        }
    },
})
